import React, { Component, Fragment } from 'react'
import { Query } from 'react-apollo'
import OldOrders from '../../components/OldOrders/'

import { OLD_ORDER_QUERY, SELF_QUERY, CATEGORIES_QUERY } from '../../queries'

import Hero from '../../components/Hero/'
import Breadcrumb from '../../components/Breadcrumb/'
import Loader from '../../components/Loader'
import Error from '../../components/Error'

import { Container } from '../../styles/defaults'

import helpers from '../../helpers'

import withHeaderFooter from '../../wrapper/withHeaderFooter'


import hero from '../../assets/hero/bestellijst/bestellijst.jpg'

class OldOrderList extends Component {
  render() {
    return (
      <Fragment>
        <Query query={OLD_ORDER_QUERY} variables={{ id: this.props.match.params.id }}>
        {({ loading, error, data }) => {
          if (loading) return <Loader from="25%" to="45%" fixed />
          if (error) return <Error error="de gebruikersgegevens" />
          const { oldOrder } = data
          if (!oldOrder) return <Error error="de gebruikersgegevens" />

          let order = {}

          oldOrder.orderParts = oldOrder.orderParts.filter(orderPart => ['AUB', 'AUF', 'AUI', 'AUL', 'AUO', 'AUW', 'FIL', 'MEU', 'MLE', 'MLEF', 'OFO', 'ONC', 'OND', 'ONF'].includes(orderPart.product.category.category) === false)

          oldOrder.orderParts.map(orderPart => {
            order[orderPart.id] = orderPart.amount
            return null
          })

          return (
            <Fragment>
              <Hero setsize="small" small={hero} medium={hero} large={hero} retina={hero} title={`Order ${oldOrder.orderNumber}`} />
              <Breadcrumb grandparent='Orderhistorie' grandparentUrl='/mijn-bedrijf/orderhistorie' title={`Order ${oldOrder.orderNumber}`} />
              <Query query={SELF_QUERY}>
                {({ loading, error, data }) => {
                  if (loading) return <Loader from="25%" to="45%" fixed />
                  if (error) return <Error error="de gebruikersgegevens" />
                  const { self } = data
                  let viewOrders = (self.permissions.includes('VIEW_OLD_ORDER') || self.role === 'MANAGER') && !this.props.branch.suspended
                  let editOrder = self.permissions.includes('REPEAT_OLD_ORDER') || self.role === 'MANAGER'

                  const { servicePackage } = oldOrder.branch
                  if (servicePackage === 'Ondersteun') {
                    editOrder = this.props.portalOrderId && (this.props.code !== '40') ? editOrder : false
                  } else {
                    editOrder = servicePackage === 'Flexibel' && (this.props.code !== '40') ? editOrder : false
                  }

                  if (viewOrders) {
                    return (
                      <Query query={CATEGORIES_QUERY}>
                        {({ loading, error, data }) => {
                          if (loading) return <Loader from="45%" to="75%" fixed />
                          if (error) return <Error error="de producten" />
                          const { categories } = data
                          const strippedProducts = helpers.strippedProducts(categories)
                          return (
                            <OldOrders
                              order={order}
                              products={this.props.products}
                              wholeOrder={oldOrder}
                              strippedProducts={strippedProducts}
                              orderId={oldOrder.id}
                              editOrder={editOrder}
                              user={self}
                              branch={this.props.branchId}
                              branchData={this.props.branch}
                          />
                          )
                        }}
                      </Query>
                    )
                  } else {
                    return (
                      <Container mt mb>
                        Onvoldoende rechten om de bestellingen te bekijken
                      </Container>
                    )
                  }
                }}
              </Query>
            </Fragment>
          )
        }}
        </Query>
      </Fragment>
    )
  }
}

export default withHeaderFooter(OldOrderList)



// WEBPACK FOOTER //
// ./src/views/OldOrderList/index.js